export default __webpack_public_path__ + "static/media/home_modal_peten.84deac0b.jpg";